/**
 * ColorSwatch — small visual color aid.
 * Renders a tiny circle filled with the HEX value if provided; falls back to a neutral disc.
 * NEVER replaces the actual material photograph — this is a hint only.
 */
export default function ColorSwatch({ hex, name, size = 18, testId }) {
  const clean = typeof hex === "string" && /^#?[0-9a-fA-F]{3,8}$/.test(hex) ? (hex.startsWith("#") ? hex : `#${hex}`) : null;
  const label = name || clean || "";
  return (
    <span
      data-testid={testId}
      title={label}
      aria-label={label}
      className="inline-block shrink-0 border align-middle"
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        background: clean || "repeating-conic-gradient(#EDEBE1 0% 25%, #F4F3ED 0% 50%)",
        borderColor: "var(--nylsu-border-strong)",
      }}
    />
  );
}
